import { render, staticRenderFns } from "./StatsRevenuePerEmployee.vue?vue&type=template&id=ff7a634a&"
import script from "./StatsRevenuePerEmployee.vue?vue&type=script&lang=js&"
export * from "./StatsRevenuePerEmployee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff7a634a')) {
      api.createRecord('ff7a634a', component.options)
    } else {
      api.reload('ff7a634a', component.options)
    }
    module.hot.accept("./StatsRevenuePerEmployee.vue?vue&type=template&id=ff7a634a&", function () {
      api.rerender('ff7a634a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/purchase-activity-flash/reports/StatsRevenuePerEmployee.vue"
export default component.exports